import { RequestRules, RulesError, RulesLoaded } from '../actions/clickupRules';

export default function clickupRules(state = null, action) {
  switch (action.type) {
    case RequestRules: {
      return Object.assign({}, state, {
        error: null,
        lastUpdated: action.timestamp,
        loading: true,
      });
    }

    case RulesLoaded: {
      return Object.assign({}, state, {
        error: null,
        rules: action.rules,
        lastUpdated: action.timestamp,
        loading: false,
      });
    }

    case RulesError: {
      return Object.assign({}, state, {
        error: action.error,
        lastUpdated: action.timestamp,
        loading: false,
      });
    }

    default:
      return state;
  }
}
